/**
 * Single source of truth for the marketing site's external references.
 * Keeps URLs, contact details, and legal dates out of the JSX so a copy
 * change is one edit, not a grep-and-pray.
 */
export const SITE = {
  name: "ARCADIA '84",
  /** The game studio behind the arcade — used in branding/credit copy. */
  studio: 'BigEgoGames',
  studioUrl: 'https://bigego.games',
  /** The legal entity — used in copyright and legal-clause copy. */
  legalEntity: 'ArcRaz LLC',
  legalEntityUrl: 'https://arcraz.com',
  tagline: 'The arcade that never closed.',
  /** Where the "PLAY" buttons go — the cabinet PWA. */
  appUrl: 'https://app.arcadia84.com',
  marketingUrl: 'https://arcadia84.com',
  /**
   * Role-based group inboxes on the product domain — never a personal
   * address. Route these to whoever owns the queue; the site only ever
   * references the alias.
   */
  emails: {
    info: 'info@arcadia84.com',
    support: 'support@arcadia84.com',
    feedback: 'feedback@arcadia84.com',
    press: 'press@arcadia84.com',
  },
  /** Bump when any legal page copy materially changes. */
  legalLastUpdated: 'July 24, 2026',
  gameCount: 20,
} as const;

export const PASSES = [
  {
    id: 'day',
    name: 'DAY PASS',
    price: '$0.99',
    period: '/ day',
    blurb: 'Unlimited plays for 24 hours. No token counting, no cooldowns.',
    accent: '#29e6ff',
  },
  {
    id: 'week',
    name: 'WEEK PASS',
    price: '$2.99',
    period: '/ week',
    blurb: 'Seven days of the whole cabinet, wide open. The regular’s pick.',
    accent: '#c8ff3d',
    featured: true,
  },
  {
    id: 'month',
    name: 'MONTH PASS',
    price: '$8.99',
    period: '/ month',
    blurb: 'Thirty-plus days unlimited. Best value if the arcade is your home turf.',
    accent: '#ff3d9a',
  },
] as const;
